<template>
	<div class="flex-start--center py-3">
		<AppGroupAvatar :group="group" />
		<div class="name px-4">
			<div class="flex-start--center">
				<div v-if="showRenamePen && hasEditPermissions" @click="renameGroup"><SIcon name="pen" :width="17" class="pen" /></div>
				<EditableTextField :text="groupName" :isEditing.sync="isEditingModuleName" @onSave="onSave" placeholder="Name your group" />
			</div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { updateGroup } from '@/store/modules/accountGroups/actions';
import { defaultGroupName } from '@/store/modules/accountGroups/getters';

import EditableTextField from '@/components/common/EditableTextField';

export default {
	name: 'GroupName',
	components: {
		EditableTextField,
	},
	props: {
		group: { type: Object },
		defaultGroupName: { type: String },
		avatarColSize: { type: String },
		showRenamePen: { type: Boolean, default: true },
		hasEditPermissions: { type: Boolean },
	},
	computed: {
		...mapGetters([defaultGroupName.fullPath]),
		groupName() {
			if (this.isEditingModuleName && this.isDefaultGroupName(this.group.name)) {
				return ''; //clear for editing
			}
			return this.group.name;
		},
	},
	methods: {
		...mapActions([updateGroup.fullPath]),

		onSave(newV) {
			this[updateGroup.fullPath]({ id: this.group.id, name: newV });
		},
		renameGroup() {
			this.isEditingModuleName = true;
		},
		isDefaultGroupName(value) {
			return value?.trim() === this[defaultGroupName.fullPath];
		},
	},
	watch: {
		name(newV) {
			if (this.isDefaultGroupName(newV)) {
				this.renameGroup();
			}
		},
	},
	mounted() {
		if (this.isDefaultGroupName(this.groupName)) {
			this.isEditingModuleName = true;
		}
	},
	data: () => ({
		isEditingModuleName: false,
	}),
};
</script>

<style scoped lang="scss">
.name {
	width: 100%;
	::v-deep {
		.v-text-field__slot {
			input {
				// text-overflow-ellipsis
				max-width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	}
}
.pen {
	padding: 1.5px;
	&:hover {
		cursor: pointer;
	}
}
</style>
